import React, { useCallback, useEffect, useState } from "react";
import CommonModal from "../../../../components/modal/CommonModal";
import InputText from "../../../../components/inputs/InputText";
import { searchPurchaseProducts } from "../../../../api/inventoryService";
import InputDropSearch from "../../../../components/inputs/InputDropSearch";
interface Product {
  productId: string;
  productName: string;
  scale: string;
  quantity: number;
  unitPrice: number;
  price: number;
  paid: Boolean;
  errors: Boolean;
}

interface Item {
  [key: string]: any;
}

interface AddProductModalProps {
  closeModal: () => void;
  addProduct: (product: Product) => void;
}

const AddProductModal: React.FC<AddProductModalProps> = ({
  closeModal,
  addProduct,
}) => {
  const [formData, setFormData] = useState<Product>({
    productId: "",
    productName: "",
    quantity: 1,
    unitPrice: 0,
    price: 0,
    scale: "",
    paid: false,
    errors: false,
  });

  const [product, setProduct] = useState<Item[]>([]);

  const handleChange = useCallback((e: any) => {
    const { name, value, valueTitle } = e.target;

    setFormData((prevData) => {
      if (name === "unitPrice") {
        return {
          ...prevData,
          [name]: value,
          price: value * prevData.quantity,
        };
      } else if (name === "price") {
        return {
          ...prevData,
          [name]: value,
          unitPrice: value / prevData.quantity,
        };
      } else if (name === "productId") {
        return {
          ...prevData,
          [name]: value,
          productName: valueTitle,
          scale: e.target.value2,
        };
      } else if (name === "quantity") {
        return {
          ...prevData,
          [name]: value,
          price: value * prevData.unitPrice,
        };
      } else {
        return { ...prevData, [name]: value };
      }
    });
  }, []);

  const getProductData = useCallback(async (search: string) => {
    try {
      const data = await searchPurchaseProducts(search);
      setProduct(data as Item[]);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getProductData("");
  }, [getProductData]);

  const searchProduct = useCallback(
    (search: string) => {
      getProductData(search);
    },
    [getProductData]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      
      if (
        formData.productId === "" ||
        formData.productName === "" ||
        formData.scale === "" ||
        formData.quantity <= 0 ||
        formData.unitPrice <= 0 ||
        formData.price <= 1
      ) {
        setFormData((prevData) => {
          return {
            ...prevData,
            errors: true,
          };
        });
      } else {
        addProduct(formData);
      }
    },
    [addProduct, formData]
  );

  return (
    <CommonModal closeModal={closeModal} title={"Add Product"}>
      <form onSubmit={handleSubmit}>
        <InputDropSearch
          data={product}
          name="productId"
          label="Product Name"
          selectName1="productName"
          selectValue="_id"
          value2Name="scale"
          onChange={handleChange}
          onSearch={searchProduct}
          errors={formData.errors && formData.productId === ""}
        />
        <InputText
          name="quantity"
          label={`Total Qantity (${formData.scale})`}
          value={formData.quantity}
          onChange={handleChange}
          type="number"
          className="form__label__none"
          errors={formData.errors && formData.quantity <= 0}
        />
        <InputText
          name="price"
          label="Total Price"
          value={formData.price}
          onChange={handleChange}
          type="number"
          errors={formData.errors && formData.price <= 0}
        />

        <button type="submit">submit</button>
      </form>
    </CommonModal>
  );
};

export default AddProductModal;
